/* Shared storefront shell: payment overflow and access to the installed consent app. */
(() => {
  const strips = new WeakSet();
  function initPayments() {
    document.querySelectorAll('[data-mh-payment-strip]').forEach(strip => {
      if (strips.has(strip)) return;
      strips.add(strip);
      const row = strip.querySelector('.mh-footer-payments');
      const hint = strip.querySelector('.mh-payment-hint');
      const update = () => {
        hint.hidden = row.scrollWidth <= row.clientWidth + 2 || row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      };
      row.addEventListener('scroll', update, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(update).observe(row);
      else window.addEventListener('resize', update);
      update();
    });
  }
  function connectConsentButton() {
    const trigger = document.querySelector('.cst-reopener-wrapper .cst-reopen-trigger');
    const buttons = document.querySelectorAll('[data-mh-cookie-settings]');
    if (!trigger || !buttons.length) return false;
    buttons.forEach(button => { button.hidden = false; });
    document.body.classList.add('mh-consent-footer-ready');
    return true;
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-mh-cookie-settings]')) return;
    // Use Consentik's own handler; the theme never changes consent values.
    document.querySelector('.cst-reopener-wrapper .cst-reopen-trigger')?.click();
  });
  initPayments();
  if (!connectConsentButton()) {
    const observer = new MutationObserver(() => { if (connectConsentButton()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', () => { initPayments(); connectConsentButton(); });
})();
